module.exports = {
  RTAutocomplete: {
    autocomplete: '_07g5',
    focus: '_3qQkg',
    suggestions: '_3-Nb6',
    values: '_14fVf',
    value: 'cBUoJ',
    up: '_3rmye',
    suggestion: '_1erPE',
    active: 'kDY3Z',
    input: '_1ryxc',
  },
  RTChip: {
    chip: '_3Iv9P',
    avatar: '_2o8mD',
    deletable: '_2hlBs',
    delete: '_3nnfj',
    deleteIcon: '_2sopz',
    deleteX: '_10NaZ',
  },
  RTAvatar: { avatar: '_3OjJz', image: '_2Ueo9', letter: '_26GdB' },
  RTInput: {
    input: 'lFVgC',
    withIcon: '_1nKdf',
    icon: '_3ga1V',
    inputElement: '_4bZUj',
    bar: '_3FySS',
    label: '_34120',
    fixed: 'GRQEP',
    required: '_2G0aY',
    hint: 'bMyi_',
    filled: '_34NWn',
    error: '_2k5Jz',
    counter: '_1oTuT',
    disabled: '_3ZfJq',
    errored: '_2s74E',
    hidden: '_2gAMv',
  },
  RTSlider: {
    container: '_-dLk',
    knob: 'kq8Om',
    innerknob: '_8VjZ5',
    snaps: '_2x5j_',
    snap: '_12aGJ',
    input: '_2JHGy',
    progress: '_2R4jW',
    innerprogress: '_3p0mR',
    slider: '_3-BtZ',
    editable: 'hkAL6',
    pinned: '_28Oo0',
    pressed: '_292qK',
    ring: '_2Oh5L',
  },
  RTProgressBar: {
    linear: '_3vxHj',
    indeterminate: '_1gPzb',
    value: 'I0PhY',
    'linear-indeterminate-bar': '_1cU21',
    buffer: 'SzbNd',
    circular: '_2j3vC',
    circle: 'DlWjM',
    'circular-indeterminate-bar-rotate': 'zfZzh',
    path: '_1xZSU',
    'circular-indeterminate-bar-dash': '_3DSlU',
    multicolor: '_3XHT8',
    colors: 'Z_PDt',
  },
};



// WEBPACK FOOTER //
// ./src/assets/react-toolbox/theme.js